import api from '../lib/api';
import { toArray } from '../lib/utils';
import type { LeadGroup, LeadGroupFormData } from '../types/leadGroup';

export const leadGroupService = {
  async getAll(): Promise<LeadGroup[]> {
    const response = await api.get('/mkt/lead-groups');
    return toArray(response.data);
  },

  async getById(id: number): Promise<LeadGroup> {
    const response = await api.get(`/mkt/lead-groups/${id}`);
    return response.data;
  },

  async create(data: LeadGroupFormData): Promise<LeadGroup> {
    const response = await api.post('/mkt/lead-groups', data);
    return response.data;
  },

  async update(id: number, data: LeadGroupFormData): Promise<LeadGroup> {
    const response = await api.put(`/mkt/lead-groups/${id}`, data);
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/mkt/lead-groups/${id}`);
  },
};
